const fab = document.querySelector('.whatsapp-fab');
const sentinel = document.querySelector('.js-whatsapp-fab-sentinel');
const stickyAddToCart = document.querySelector('.product__add-to-cart--sticky');
const stickyOffsetGap = 16;

const updateStickyAddToCartOffset = () => {
    if(!stickyAddToCart?.hasAttribute('data-visible')) {
        document.documentElement.style.removeProperty('--whatsapp-fab-sticky-offset');
        return;
    }

    document.documentElement.style.setProperty(
        '--whatsapp-fab-sticky-offset',
        `${stickyAddToCart.getBoundingClientRect().height + stickyOffsetGap}px`,
    );
};

if (stickyAddToCart) {
    new ResizeObserver(updateStickyAddToCartOffset).observe(stickyAddToCart);
    new MutationObserver(updateStickyAddToCartOffset).observe(stickyAddToCart, {
        attributes: true,
        attributeFilter: ['data-visible'],
    });
    window.addEventListener('resize', updateStickyAddToCartOffset, {passive: true});
    updateStickyAddToCartOffset();
}

if (fab && sentinel) {
    const observer = new IntersectionObserver(([entry]) => {
        fab.toggleAttribute('data-hidden', entry.isIntersecting);
    }, {threshold: 0});

    observer.observe(sentinel);
}
